import { Button, ButtonProps } from "@mantine/core";
import styles from "./styles.module.scss";

type CallToActionProps = ButtonProps & {
  onClick?: () => void;
  type?: "submit" | "reset" | "button";
};

export function CallToAction({ children, type, ...props }: CallToActionProps) {
  return (
    <Button type={type || "submit"} className={styles.button} {...props}>
      {children}
    </Button>
  );
}
